import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	filterInputLabel: {
		id: 'project.directories.components.header.filterInputLabel',
		defaultMessage: 'Filter components',
	},
	addComponent: {
		id: 'project-components.add-component.trigger',
		defaultMessage: 'Create component',
		description: '',
	},
	caption: {
		id: 'project-components.header-caption',
		defaultMessage: 'Components',
		description: '',
	},
	successFlagTitle: {
		id: 'project-components.add-component.success-flag-title',
		defaultMessage: 'Success',
		description: '',
	},
	successFlagDescription: {
		id: 'project-components.add-component.success-flag-description',
		defaultMessage: 'New component was created successfully',
		description: '',
	},
});
